import "./Sales.css";
import { useState } from "react";
import { Helmet } from "react-helmet";
import Sidebar from "../components/Sidebar/Sidebar";
import Topbar from "../components/Topbar/Topbar";
import Search from "./components/Search/Search";
import RecentSales from "./components/RecentSales/RecentSales";
import SalesModal from "../components/Modals/RecentSales/RecentSales";
import SidebarMobile from "../components/Sidebar/Mobile/SidebarMobile";

const Sales = () => {
 const [recentSalesModal, setRecentSalesModal] = useState(false);

 return (
  <div className="sales-dashboard">
   <Helmet>
    <title> Sales | Dashboard | SHAP</title>
    <meta
     name="description"
     content="Knowledge-based digital products distribution at a premium"
    />
   </Helmet>
   <div className="wrapper">
    <div className="side-bar">
     <Sidebar active="sales" />
    </div>
    <div className="side-bar-mobile">
     <SidebarMobile active="sales" />
    </div>
    <div className="content-container">
     <div className="modal-wrapper">
      <div style={{ display: recentSalesModal ? "block" : "none" }}>
       <SalesModal setRecentSalesModal={setRecentSalesModal} />
      </div>
     </div>

     <Topbar heading="Affiliate Sales" />

     <div className="inner-content">
      <p style={{ color: "var(--primary-grey-text)" }}>
       Dashboard {"  >  "} Affiliate Sales
      </p>
      <div className="search-wrapper">
       <Search />
      </div>
      <div className="products-wrapper">
       <RecentSales setRecentSalesModal={setRecentSalesModal} />
      </div>
     </div>
    </div>
   </div>
  </div>
 );
};

export default Sales;
